import styled from 'styled-components'
import { SmallButton } from '../../components'

export const LegendButtonContainer = styled.div`
  position: absolute;
  top: 2rem;
  z-index: 10;
  width: calc(100% - 4rem);
  padding: 0 2rem;
`

export const FullWidthButton = styled(SmallButton)`
  width: 100%;
  max-width: 400px;
`
